import React, {Component} from 'react';

class Article extends Component {


    render() {
        return (

            <div id="article" className="row home-block">

                <h2 className="title">Modèles pour la data science</h2>
                <h3>Intervenante</h3>
                <p>Cours <a href="http://irma.math.unistra.fr/~mmaumy/index.html">Myriam Maumy Bertrant</a> TD : <a
                    href="/#Menu">Emmanuelle Claeys</a></p>
                <h3>Description</h3>
                <p>Le but de ce cours est de comprendre les conceptes statistique qui interviennent en Machine Learning.<br/>
                    La théorie portera sur le vocabulaire probabiliste, les tests statistiques et les méthodes de
                    modèlisation<br/>
                    Les TD vous permetteront de savoir comment extraires des informations utiles d'une base de donnée,
                    utiliser un test statistique et mettre en place un modèle prédictif. <br/><br/>
                    Vous devriez, à la fin de ce cours, comprendre le travail d'un <span className="italique">data scientist</span>.
                </p>

                <h3>Cours et slides</h3>
                <li><a
                    href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/Predictives.pdf">Cours
                    1 et 2</a>
                </li>
                <li><a
                    href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/Textmining.pdf">Cours
                    3</a>
                </li>
                


                <h3>Travaux dirigés</h3>
                <li><a
                    href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/TD1__Modele_pour_la_data_science_2018_2019_DTE.pdf">TD
                    1 </a>
                    <a href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/TD_1_modeles_pour_la_datascience_2018_2019_correction.R"> TD
                        1 correction
                    </a>
                </li>
                <li><a
                    href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/TD2__Modele_pour_la_data_science_2018_2019_DTE_.pdf">TD
                    2</a>,
                    <a href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/TD_2_modeles_pour_la_datascience_2018_2019_correction.R">TD
                        2 correction</a>,
                    <a href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/Salaries.csv"> données
                        1</a> et
                    <a href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/titanic.csv"> données
                        2</a>.
                </li>
                <li><a
                    href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/TD3__Modele_pour_la_data_science_2018_2019_DTE.pdf">TD
                    3</a>,
                    <a href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/TD_3_modeles_pour_la_datascience_2018_2019_correction.R">TD
                        3 correction</a>,
                    <a href="https://github.com/manuclaeys/esiea_modeles_pour_la_data_science_2018_2020/blob/master/urls.csv"> données </a>.
                </li>


                <h3>Examen</h3>
                <li> Voici quelques rapports d'analyse réalisés par les étudiants sur <a
                    href="https://github.com/manuclaeys/esiea_Analyse_exploratoire_2017_2018/blob/master/Analyse%20et%20Modeles%20-%20BRUN%2C%20CAGNON%2C%20MARTIN.pdf">les
                    courses hippiques</a>,
                    <a href="https://github.com/manuclaeys/esiea_Analyse_exploratoire_2017_2018/blob/master/Rapport%20-%20Analyse%20exploratoire%20-%20Benedetti%20-%20Garnier%20-%20Sazadaly.pdf">YOUTUBE</a> ou
                    encore les
                    <a href="https://github.com/manuclaeys/esiea_Analyse_exploratoire_2017_2018/blob/master/Rapport%20LE%20CAM-CORREGGIO-ERDEM.pdf"> ventes
                        de voiture</a>.
                </li>


                <h3>Retours étudiants</h3>
                <li> Les retours des étudiants sont visibles sur <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSf8ENZNPcvdyewAAALE4K-h6OQkvrca9uTx5s9HgHrKiB81EA/viewanalytics">ce
                    lien</a>.

                </li>


            </div>

        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/CoursModelesPourLaDatascience2018/index.js